/*

URL-Parameter:

- l=0: Deutsch (default), l=1: Englisch
- id=[oxId]: zu ladende Konfiguration (default: erste Standardkonfiguration)
- b2=b: B2B-Modus (default), b2=c: B2C-Modus
- debug=true: aktiviert Debug-Nachrichten in der Konsole (default: aus)
- offline=true: lädt lokale Testdaten anstatt der live-JSONs (default: aus)
- forceDb=1: Umgeht das Caching der JSONs (default: aus)



STRUKTUR:

App
 |
 +-- Preview: Großes Bild, Logo
 |
 +-- Main: Optionen, Preis & Warenkorb, Sprachwähler
     |
     +-- SidebarSection: Allgemeiner Sidebar-Abschnitt mit Titel, Bearbeiten-Button, Zusammenfassung und Weiter-Button
     |
     +-- BuyBox: Gesamtpreis, Warenkorb-Button



UNTERKOMPONENTEN:

- RadioLines: Optionsauswahl mit Name, Beschreibung, Info-Icon, Radiobutton
- RadioCards: Optionsauswahl mit Name, Beschreibung, Preis, Bild
- RadioSwatches: Auswahl für Stoffe, jeweils mit Bild, gruppiert nach Art und Modell
- RadioGrouped: Auswahl mit einem Bild und mehreren Optionen, für die Fußsets
- Modal: allgemeines modales Fenster mit Shader, Header mit Titel und Schließen-Button, Footer mit Filtern und OK-Button

 */

import {useEffect, useState} from 'react'

/* Internationalisierung: */
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import {messages} from './locales/de/messages'
import {messages as messages_en} from './locales/en/messages'

import Main from './components/Main'
import {logDebug} from './components/helpers/general'

const queryStringParams = new URLSearchParams(window.location.search);

if (queryStringParams.get("id")) {
    window.configId = queryStringParams.get("id")
} else {
    window.configId = ''
}

window.b2bShopUrl = 'https://www.fbf-bedandmore.de/'
window.b2cShopUrl = 'https://www.fbf-home.de/'
window.dataShopUrl = window.b2bShopUrl  // von dieser URL werden die Konfiguratordaten abgerufen

// wenn nicht explizit B2C aufgerufen wird, ist der B2B-Modus aktiv:
if (queryStringParams.get("b2") === "c") {
    window.b2b = false
    window.shopUrl = window.b2cShopUrl
    //window.shopUrl = 'http://fbf.localhost/'
    window.apiPath = 'api/v1.php/'
} else {
    window.b2b = true
    window.shopUrl = window.b2bShopUrl
    window.apiPath = 'api/v1.php/'
}

// Debugging-Nachrichten in der Konsole ausgeben?
if ( (queryStringParams.get("debug") === "true") || (queryStringParams.get("debug") === "1") ) {
    window.debug = true
} else {
    window.debug = false
}

// lokale Testdaten statt der live-JSONs laden?
if ( (queryStringParams.get("offline") === "true") || (queryStringParams.get("offline") === "1") ) {
    window.offline = true
    console.warn('Offline-Modus aktiv - lokale Testdaten statt live-Daten werden verwendet.')
} else {
    window.offline = false
}

// Caching der live-JSONs umgehen?
if ( (queryStringParams.get("forceDb") === "true") || (queryStringParams.get("forceDb") === "1") ) {
    window.forceDb = "&forceDb=1"
    console.warn('Daten werden ohne Caching aus der DB geladen (langsamer, aber immer aktuell).')
} else {
    window.forceDb = ""
}

window.lang = queryStringParams.get("l");
if (window.lang === "en") {
    i18n.load('en', messages_en)
    i18n.activate('en')
    window.langNum = 1
} else {
    i18n.load('de', messages)
    i18n.activate('de')
    window.langNum = 0
}

function App() {

    const [allOptions, setAllOptions] = useState([])
    useEffect(() => {
        const fetchJson = window.offline ? `dummyConfiguration-${window.langNum}.json` : `${window.dataShopUrl}${window.apiPath}configuration/${window.configId}?language=${window.langNum}&b2=${window.b2b ? 'b' : 'c'}${window.forceDb}`
        logDebug(`Konfiguratordaten aus: ${fetchJson}`)
        fetch(fetchJson,
           {credentials: 'include'}
        )
            .then(res => res.json())
            .then(data => setAllOptions(data))
    }, [])

    return (
        <I18nProvider i18n={i18n}>
            <Main expanded='size' allOptions={allOptions} shopUrl={window.shopUrl} dataShopUrl={window.dataShopUrl} />
        </I18nProvider>
    )

}

export default App
